import { useEffect, useState } from "react";
import loader from "../../assets/icon-loader-queencenter.svg";
// import { BeatLoader } from "react-spinners";

const Loader = () => {
  const [secondsLeft, setSecondsLeft] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading_page">
      <div className="loading_container">
        <img src={loader} alt="Loading Logo" className="loading_logo" />
        <h2 className="loading_title">{secondsLeft}</h2>
        <p className="loading_text text-muted ">
          Jouw beauty moment wordt klaargezet.
          <br />
          Bezig met het gladstrijken van de wachttijd.
        </p>
      </div>
    </div>
  );
};

export default Loader;
